module.exports = __webpack_public_path__ + "img/deezer.c4ddb2fb.svg";